const DEV_HOST = 'https://trazoevents.com'
const PROD_HOST = window.location.protocol + '//' + window.location.hostname

export const isDev = process.env.NODE_ENV === 'development'

export const apiURL = isDev ? `${DEV_HOST}/api` : `${PROD_HOST}/api`

export const siteName = 'Apolix'

export const siteDescription = 'La ciudad de las apps'

export const siteURL = isDev ? DEV_HOST : PROD_HOST

